import store from '@/store/store';

export default {
  path: 'dashboard',
  name: 'app-dashboard',
  component: () => import('@/views/app/Dashboard.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'dashboard.header_title';

    const dashboardResource = await store.state.router.privateRoot.$request().$get('dashboard');
    store.commit('router/updateRouteProp', {
      property: 'dashboardResource',
      value: dashboardResource
    });
    next();
  },
  props: () => ({
    dashboardResource: store.state.router.dashboardResource
  })
};
